import styled from 'styled-components';
import { ModalOfferExpiredStyled } from '../../ModalOfferExpiredStyled';
import { rem } from 'polished';

export const ModalOfferExpiredStyledOV = styled(ModalOfferExpiredStyled)`
    
`;
